import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ProductLogo from '@shared/ProductLogo/ProductLogo';
import Menu from './Menu/Menu';
import Socials from './Socials/Socials';
import classes from './Footer.module.scss';
import classNames from 'classnames';
import { copyright, disclaimer } from '@configs/footer';
const Footer = () => (_jsxs("footer", { className: classes.container, children: [_jsx(ProductLogo, { className: classes.logo }), _jsxs("div", { className: classes['menu-wrapper'], children: [_jsx(Menu, {}), _jsx(Socials, {})] }), _jsxs("div", { className: classes['info-wrapper'], children: [_jsx("p", { className: classNames(classes.text, 'text-secondary'), children: disclaimer }), _jsx("p", { className: `${classes.copyright} text-secondary`, children: copyright })] })] }));
export default Footer;
